import { Button, Grid, IconButton, makeStyles, Modal } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import CustomButton from '../../../../control/button/Button';
import EventDetailDescription from './EventDetailDescription';
import UseAlertMessageState from '../../../../control/alert/UseAlertMessageState';
import UseLoadingState from '../../../../control/loading/UseLoadingState';
import { checkResStatusService } from '../../../../utilities/ResServiceUtils';
import * as AlertMSGConstants from '../../../../constants/AlertMSGConstants';
import AlertMessage from '../../../../control/alert/AlertMessage';
import Loading from '../../../../control/loading/Loading';
import { RemoveRedEye } from '@material-ui/icons';
import { GetApp } from '@material-ui/icons';
// import { HelpOutlineIcon } from '@material-ui/icons/HelpOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ControlButton from '../../../../control/button/Button';
import {
    useHistory,
    useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import ModalImageFullScreen from '../../ModalImageFullscreen';

const useStyles = makeStyles((theme) => ({
    spacing: {
        ...theme.form.spacing,
    },
    root: {
        padding: '24px',
    },
    rootPaper: {
        width: '100%',
        overflowX: 'hidden',
        padding: '24px 0px 24px 0px',
    },
    rootGridDetails: {
        width: '100%',
        [theme.breakpoints.down('xl')]: {
            borderRight: `1px solid ${theme.palette.divider}`,
        },
    },
    divider: {
        margin: '24px 0px',
    },
    tableCell: {
        padding: '20px',
    },
    btnSearch: {
        width: '105px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    btnReset: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
        width: '105px',
        marginRight: '8px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginRight: '0px',
            marginBottom: '2%',
        },
    },
    btnCloseModal: {
        backgroundColor: '#808080 !important',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        maxHeight: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: theme.palette.background.paper,
        width: '50%',
        [theme.breakpoints.down('sm')]: {
            width: '75%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    body: {
        padding: theme.spacing(3),
    },
    label: {
        fontWeight: 'bold',
    },
    modalItemTable: {
        minWidth: 'auto',
    },
    btnSearchDetail: {
        width: '244px',
        height: '40px',
        marginTop: '26px',
    },
    qrTitle: {
        fontSize: '24px',
        fontWeight: '700',
        textAlign: 'center',
    },
    qrDesc: {
        fontSize: '18px',
        fontWeight: '500',
        textAlign: 'center',
    },
    qrGridContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    eventDetailTitle: {
        fontSize: '24px',
        fontWeight: '500',
    },
    bannerWrapper: {
        position: 'relative',
        height: '377px',
        overflow: 'hidden',
        '&:hover $overlayButton': {
            opacity: 1,
            pointerEvents: 'auto',
        },
    },
    image: {
        width: '100%',
        height: '377px',
        objectFit: 'cover',
        objectPosition: 'top',
    },
    imageModal: {
        width: '100%',
        height: '100%',
        objectFit: 'scale-down',
        objectPosition: 'top',
    },
    overlayButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: 0,
        transition: 'opacity 0.3s ease',
        backgroundColor: 'rgba(0,0,0,0.3)',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '8px',
        cursor: 'pointer',
        pointerEvents: 'none',
        width: '53px',
        height: '53px',
    },
    detailContainer: {
        paddingTop: '24px',
        paddingLeft: '46px',
        [theme.breakpoints.down('sm')]: {
            padding: '24px 24px 0px 24px',
        },
    },
    qrBtnContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        marginTop: '30px',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            padding: '12px 12px 12px 12px',
        },
    },
    qrBtn: {
        border: '1px solid #E3E3E3',
        borderRadius: '12px',
        color: '#F47B15',
        fontWeight: '500',
        justifyContent: 'flex-start',
        padding: '18px 37px 18px 37px',
        height: '54px',
        width: '100%',
        textWrap: 'nowrap',
        '& svg': {
            marginRight: '24px',
        },
        maxWidth: '434px',
        [theme.breakpoints.down('md')]: {
            padding: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            '& svg': {
                marginRight: '6px',
            },
        },
    },
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '24px',
        [theme.breakpoints.down('md')]: {
            padding: '12px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: 0,
        },
    },
    btnEdit: {
        backgroundColor: '#808080 !important',
        width: '244px',
        maxWidth: '244px',
        height: '40px',
        [theme.breakpoints.down('sm')]: {
            order: 2,
        },
    },
    btnBack: {
        width: '244px',
        maxWidth: '244px',
        height: '40px',
        [theme.breakpoints.down('sm')]: {
            order: 1,
        },
    },
    controlBtnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '72px',
        gap: '38px',
        [theme.breakpoints.down('md')]: {
            paddingLeft: '46px',
            marginTop: '36px',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            marginTop: '36px',
            paddingLeft: '0px',
        },
    },
    noImage: {
        width: '100%',
        height: '100%',
        background: 'gainsboro',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '40px',
        [theme.breakpoints.down('xs')]: {
            // height: '250px',
            width: '100%',
        },
    },
}));

const EventDetailInformation = (props) => {
    const history = useHistory();
    const { eventData, alertMessageState, loadingState } = props;
    const [open, setOpen] = useState(false);
    const handleModalBehavior = useCallback(() => {
        setOpen((prev) => !prev);
    }, [setOpen]);
    const [instructionModalOpen, setInstructionModalOpen] = useState(false);
    const handleInstructionModalBehavior = useCallback(() => {
        setInstructionModalOpen((prev) => !prev);
    }, [setInstructionModalOpen]);
    const classes = useStyles();
    const { eventId } = useParams();

    const handleClickBack = useCallback(() => {
        history.push(`/event`);
    }, [history]);

    const handleClickEdit = useCallback(() => {
        history.push(`/event/${eventId}/edit`);
    }, [history, eventId]);

    const handleClickDownloadQR = useCallback(() => {
        if (eventData) {
            const qrcodeImage = eventData.qrcodeImage;
            if (qrcodeImage) {
                loadingState.showLoading();
                fetch(qrcodeImage)
                    .then((res) => res.blob())
                    .then((blob) => {
                        const mimeType = blob.type;
                        const extension = mimeType.split('/')[1];
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;

                        link.setAttribute('download', `qrcode.${extension}`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    })
                    .finally((err) => {
                        loadingState.hideLoading();
                    });
            }
        }
    }, [eventData, loadingState]);
    return (
        <>
            <Grid container className={classes.rootPaper}>
                <Grid item xs={12}>
                    <Grid item xs={12} className={classes.rootGridDetails}>
                        <div
                            style={{
                                fontWeight: '400',
                                fontSize: '33px',
                                paddingLeft: '46px',
                                paddingBottom: '16px',
                            }}
                        >
                            ข้อมูลกิจกรรม
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.bannerWrapper}>
                            {eventData && eventData.coverImage ? (
                                <>
                                    <img
                                        src={eventData.coverImage}
                                        alt="img"
                                        className={classes.image}
                                        onClick={handleModalBehavior}
                                    />
                                    <IconButton
                                        onClick={handleModalBehavior}
                                        className={classes.overlayButton}
                                    >
                                        <RemoveRedEye
                                            color="primary.dark"
                                            style={{
                                                fontSize: 24,
                                                opacity: 0.3,
                                            }}
                                        />
                                    </IconButton>
                                </>
                            ) : (
                                <div className={classes.noImage}>ไม่มีรูป</div>
                            )}
                        </div>
                    </Grid>
                    <Grid container className={classes.detailContainer}>
                        <Grid item xs={12} lg={8}>
                            {eventData && (
                                <EventDetailDescription eventData={eventData} />
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={4}
                            className={classes.qrGridContainer}
                        >
                            <div className={classes.container}>
                                <div className={classes.qrTitle}>
                                    สำหรับลงทะเบียนล่วงหน้า
                                </div>
                                {eventData && eventData.qrcodeImage && (
                                    <img
                                        style={{
                                            width: '276px',
                                            height: '276px',
                                            textAlign: 'center',
                                        }}
                                        src={eventData.qrcodeImage}
                                    />
                                )}
                                <div className={classes.qrDesc}>
                                    แสกนเพื่อลงทะเบียนล่วงหน้า
                                </div>

                                <div className={classes.qrBtnContainer}>
                                    <Button
                                        className={classes.qrBtn}
                                        onClick={handleClickDownloadQR}
                                    >
                                        <GetApp fontSize={'small'} />
                                        <div>ดาวน์โหลด QR CODE</div>
                                    </Button>
                                    <Button
                                        className={classes.qrBtn}
                                        onClick={handleInstructionModalBehavior}
                                    >
                                        <HelpOutlineIcon fontSize={'small'} />
                                        <div>
                                            วิธีการลงทะเบียน ณ วันจัดกิจกรรม
                                        </div>
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.controlBtnContainer}>
                        <ControlButton
                            label="กลับไปหน้าจัดการกิจกรรม"
                            className={classes.btnEdit}
                            onClick={handleClickBack}
                        />
                        {eventData && eventData.canEdit && (
                            <ControlButton
                                label="แก้ไขข้อมูลกิจกรรม"
                                className={classes.btnBack}
                                onClick={handleClickEdit}
                            />
                        )}
                    </Grid>
                </Grid>

                <AlertMessage {...alertMessageState.altProps} />
                <Loading isShowLoading={loadingState.isShowLoading} />
                {/* Footer ปิด/แก้ไขข้อมูลกิจกรรม */}
            </Grid>
            {eventData && eventData.coverImage && (
                <ModalImageFullScreen
                    img={eventData.coverImage}
                    open={open}
                    onClose={handleModalBehavior}
                />
            )}
            <ModalImageFullScreen
                img={
                    process.env.PUBLIC_URL +
                    '/img/event/Instruction_Creator.jpg'
                }
                open={instructionModalOpen}
                onClose={handleInstructionModalBehavior}
            />
        </>
    );
};

export default EventDetailInformation;
